import React, { useEffect, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { useAbility } from '@casl/react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useDispatch } from 'react-redux';
// import ShiftInfo from './ShiftInfo';
import { Icon } from '../../../components';
import { useSetTab } from '../../../services/hooks';
import { AbilityContext } from '../../../config/abilityContext';
import ShiftAssignmentsInfo from '../ShiftAssignments/ShiftAssigmentsInfo';
import { getMeRequest } from '../../../requests/auth';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';
import { validateToken } from '../../../actions/auth';
import MyShiftsInfo from './MyShiftsInfo';

const basicUser = {
  avatar: [],
  email: '',
  id: '',
  name: '',
  first_name: '',
  nationalIdentification: '',
  role: '',
  employeeCard: {
    fileInfo: {}
  }
};

const ShiftProfileShow = () => {
  const dispatch = useDispatch();
  const ability = useAbility(AbilityContext);
  const location = useLocation();
  const [user, setUser] = useState(basicUser);

  const defaultKey = () => {
    if (ability.can('show', 'Shifts')) return 'shifts';
    if (ability.can('show', 'ShiftAssignments')) return 'shift_assignments';
    return 'shifts';
  };

  const [key, setKey] = useSetTab(defaultKey(), location);

  const dispatchGetMe = () => {
    getMeRequest({
      dispatch,
      successCallback: response => {
        if (response.data.logged_in) {
          setUser(camelCaseEmptyStringRecursive(response.data.user_info));
        } else {
          dispatch(validateToken());
        }
      }
    });
  };
  useEffect(dispatchGetMe, []);

  return (
    <>
      <h2 className="m-top mb-3">&nbsp;</h2>
      <Tab.Container id="profile-index.tabs" activeKey={key} onSelect={k => setKey(k)} mountOnEnter>
        <Nav variant="pills">
          {ability.can('read', 'Shift') && (
            <Nav.Item>
              <Nav.Link className="mb-1 mt-2" eventKey="shifts">
                <Icon icon="user-check" />
                Mi Turno
              </Nav.Link>
            </Nav.Item>
          )}
          {ability.can('read', 'ShiftAssignment') && (
            <Nav.Item>
              <Nav.Link className="mb-1 mt-2" eventKey="shift_assignments">
                <Icon icon="calendar" />
                Mi Asignación Turno
              </Nav.Link>
            </Nav.Item>
          )}
        </Nav>
        <div className="col-sm-12 MainDivHrCard mb-4">
          <Tab.Content>
            <Tab.Pane eventKey="shifts">
              <MyShiftsInfo user={user} />
            </Tab.Pane>
            <Tab.Pane eventKey="shift_assignments">
              <ShiftAssignmentsInfo />
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </>
  );
};

export default ShiftProfileShow;
